import { LinearProgress } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import React from 'react'

interface SingleSelectDropdownProps {
  label: string
  options: string[]
  defaultValue?: number | string
  styles?: any
  onChange: (value: string) => void
  fullWidth?: boolean
  disabled?: boolean
  loading?: boolean
  dataCy?: string
}

export const SingleSelectDropdown: React.FC<SingleSelectDropdownProps> = ({
  label,
  options,
  defaultValue,
  styles = {},
  onChange,
  fullWidth,
  disabled = false,
  loading = false,
  dataCy,
}) => {
  const onValueChange = (event: SelectChangeEvent<any>) => {
    onChange(event.target.value)
  }

  const safeValue = options.includes(defaultValue as string) ? defaultValue : ''

  return (
    <FormControl
      sx={{ minWidth: 180, ...styles }}
      size='small'
      fullWidth={fullWidth}
      disabled={disabled || loading}
    >
      <InputLabel id={`${label}-label`}>
        {loading ? 'Loading...' : label}
      </InputLabel>
      <Select
        labelId={`${label}-label`}
        id={`${label}-select`}
        value={safeValue}
        label={loading ? 'Loading...' : label}
        onChange={onValueChange}
        data-cy={dataCy}
      >
        {loading ? (
          <MenuItem value=''>
            <LinearProgress />
          </MenuItem>
        ) : (
          options.map((option, index) => (
            <MenuItem key={index + 1} value={option}>
              {option}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  )
}
